import SignUp from './SignUp'
import './SignUp.css'

export default SignUp



// WEBPACK FOOTER //
// ./src/features/Personal/containers/SignUp/index.js